'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FilterToggleGroupSection } from './filter-toggle-group-section.component';

import {
  SearchFilterProfessionalGenderMap,
  SearchFilterProfessionalGenderType,
  searchFilterProfessionalGenderOptions,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';

const options = searchFilterProfessionalGenderOptions.map((value) => ({
  value,
  label: SearchFilterProfessionalGenderMap[value],
}));

export const professionalGenderOptionTestId = (value: SearchFilterProfessionalGenderType): string =>
  `${DataTestIdEnum.SEARCH_FILTERS_PROFESSIONAL_GENDER_OPTION}-${value}`;

interface ProfessionalGenderFilterSectionProps {
  value: SearchFilterProfessionalGenderType;
  onChange: (value: SearchFilterProfessionalGenderType) => void;
}

export function ProfessionalGenderFilterSection({ value, onChange }: ProfessionalGenderFilterSectionProps) {
  return (
    <FilterToggleGroupSection
      label="Profissionais"
      value={value}
      options={options}
      onChange={onChange}
      testId={DataTestIdEnum.SEARCH_FILTERS_PROFESSIONAL_GENDER}
      getOptionTestId={professionalGenderOptionTestId}
    />
  );
}
